import { Col, Row, Form, Select, message } from 'antd';
import React, { useEffect, useState } from 'react';
import axios from '../../../config/axios';
import { urls } from '../../../constants';
import getErrorMessage from '../../utils-components/getErrorMessage';

// Conjunto de "selects" para Ciudad y Barrio dentro del "collapse" de "Push Zonas"
// * "tipoZona" retorna un numero que indica si la zona seleccionada es "Zona
//    Geografica", que al detectar cambio obtiene la lista de ciudades o bien realiza
//    la limpieza del componente.
// * "pushForm" permite acceso al "formulario" se utiliza para establecer datos
//    programaticamente.
// * "fields" contienen los datos del "formulario", se utiliza para detectar su contenido
//    "null", lo que significa que se presiono el boton de "restablecer" y ejecutar las
//    instrucciones de limpieza del componente.

const PushZonaMapGeograficaPersonalizada = ({
    tipoZona,
    pushForm,
    fields,
    setCantidadUsuariosSeleccionados,
}) => {
    // State para "select" de cuidades
    const [ciudades, setCiudades] = useState(); // Datos a mostrar en el select
    const [deshabilitarCiudades, setDeshabilitarCiudades] = useState(true);
    const [cargandoCiudades, setCargandoCiudades] = useState();
    const [requiredCiudades, setRequiredCiudades] = useState(false);

    // Obtener datos de "cuidades" del "endpoint"
    const obtenerCiudades = async () => {
        let arrCiudades = [];

        try {
            setCargandoCiudades(true);

            const respuesta = await axios.get('/city_names');

            respuesta.data.data.cities.map((item) => arrCiudades.push(item));
        } catch (error) {
            message.error(
                'Hubo un problema al obtener los datos de las ciudades',
            );
            console.log(
                'Hubo un problema al obtener los datos de las ciudades',
                error,
            );
        }

        setCargandoCiudades(false);

        if (arrCiudades.length > 0) {
            setCiudades(arrCiudades);
            setDeshabilitarCiudades(false);
            setRequiredCiudades(true);
        } else {
            setCiudades(null);
            setDeshabilitarCiudades(true);
            setRequiredCiudades(false);
        }
    };

    // Manejar cambio de "ciudad" en el "select"
    function handleChangeCiudades(value) {
        if (value && Number(value)) {
            setDeshabilitarBarrios(false);
            obtenerBarrios(value);
            setRequiredBarrios(true);
        } else {
            setDeshabilitarBarrios(true);
        }
        pushForm.setFieldsValue({ barrio: null });
    }

    // State para "select" de cuidades
    const [barrios, setBarrios] = useState(); // Datos a mostrar en el "select"
    const [deshabilitarBarrios, setDeshabilitarBarrios] = useState(true);
    const [cargandoBarrios, setCargandoBarrios] = useState();
    const [requiredBarrios, setRequiredBarrios] = useState(false);

    // Obtener datos de "barrios" del "endpoint"
    const obtenerBarrios = async (city_id) => {
        let arrBarrios = [];

        try {
            setCargandoBarrios(true);

            const respuesta = await axios.get('/neighborhoods', {
                params: { city_id: city_id },
            });

            respuesta.data.data.neighborhoods.map((item) =>
                arrBarrios.push(item),
            );
        } catch (error) {
            message.error(
                'Hubo un problema al obtener los datos de las barrios',
            );
            console.log(
                'Hubo un problema al obtener los datos de las barrios',
                error,
            );
        }

        setCargandoBarrios(false);

        if (arrBarrios.length > 0) {
            setBarrios(arrBarrios);
            setDeshabilitarBarrios(false);
            setRequiredBarrios(true);
        } else {
            setBarrios(null);
            setDeshabilitarBarrios(true);
            setRequiredBarrios(false);
        }
    };

    const handleChangeBarrios = () => {
        const ciudad = Number(pushForm.getFieldsValue(['ciudad']).ciudad);
        const barrio = Number(pushForm.getFieldsValue(['barrio']).barrio);
        // console.log(ciudad, barrio);
        obtenerCantidadUsuarios(ciudad, barrio);
    };

    // Obtener cantidad de usuarios por zona geografica
    const obtenerCantidadUsuarios = async (cities_id, neighborhoods_id) => {
        let cantidadUsuarios = 0;

        try {
            let data = {};
            data['axiosBaseURL'] = urls.REACT_APP_BACKEND_URL_C;
            data['cities_id'] = [cities_id];
            data['neighborhoods_id'] = [neighborhoods_id];

            const respuesta = await axios.post('/get_users_for_push', data);

            respuesta.data.data.forEach((item) => {
                try {
                    cantidadUsuarios += Number(item.count);
                } catch (e) {
                    cantidadUsuarios += 0;
                }
            });
        } catch (error) {
            const errorMessage = getErrorMessage(
                error,
                'Hubo un problema al obtener el alcance de esta zona',
            );
            message.error(errorMessage);
        }

        setCantidadUsuariosSeleccionados(cantidadUsuarios);
    };

    // Limpiar seleccion de "ciudad, barrio" del "select" en el formulario
    const limpiarFormSelect = () => {
        // Limpiar datos de los selects Zona Geografica
        setCiudades(null);
        setDeshabilitarCiudades(true);
        setRequiredCiudades(false);
        pushForm.setFieldsValue({ ciudad: null });
        setBarrios(null);
        setDeshabilitarBarrios(true);
        setRequiredBarrios(false);
        pushForm.setFieldsValue({ barrio: null });
    };

    // Ejecutar limpieza de la seleccion de "cuidad, barrio" al detectar cambio en "tipoZona"
    useEffect(() => {
        if (fields === null) {
            limpiarFormSelect();
        }
    }, [tipoZona, fields]);

    // Obtener lista de "ciudades" al cargar el componentes
    useEffect(() => {
        if (tipoZona === '2') {
            obtenerCiudades();
        }
    }, [tipoZona]);

    return (
        <Row gutter="24">
            <Col span="12">
                <Form.Item
                    name="ciudad"
                    label="Ciudad"
                    rules={[{ required: requiredCiudades }]}>
                    <Select
                        name="ciudad"
                        showSearch
                        optionFilterProp="children"
                        loading={cargandoCiudades}
                        disabled={deshabilitarCiudades}
                        onChange={handleChangeCiudades}
                        filterOption={(input, option) =>
                            option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                        }>
                        {ciudades?.map((item) => (
                            <Select.Option
                                key={item.city_id}
                                value={item.city_id}>
                                {item.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </Col>
            <Col span="12">
                <Form.Item
                    name="barrio"
                    label="Barrio"
                    rules={[{ required: requiredBarrios }]}>
                    <Select
                        name="barrio"
                        showSearch
                        optionFilterProp="children"
                        loading={cargandoBarrios}
                        disabled={deshabilitarBarrios}
                        onChange={handleChangeBarrios}
                        filterOption={(input, option) =>
                            option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                        }>
                        {barrios?.map((item) => (
                            <Select.Option
                                key={item.city_id}
                                value={item.city_id}>
                                {item.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </Col>
        </Row>
    );
};

export default PushZonaMapGeograficaPersonalizada;
